import { Box, Heading, HeadingProps } from '@wix/design-system';
import s from './EmptyStateBanner.module.scss';

export interface EmptyStateBannerProps {
  children: React.ReactElement;
  title: string;
  headingProps?: HeadingProps;
  className?: string;
}

export const EmptyStateBanner = ({
  children,
  title,
  headingProps,
  className,
}: EmptyStateBannerProps) => {
  return (
    <Box
      direction="vertical"
      className={className ? className : s.emptyStateBannerContainer}
    >
      <Heading as="h2" size="large" {...headingProps} ellipsis>
        {title}
      </Heading>
      {children}
    </Box>
  );
};
